import { Reveal } from "@/components/site/Reveal";

const CHAPTERS = [
  "It will understand context.",
  "Coordinate people.",
  "Automate action.",
  "And continuously improve decision making.",
];

export function Vision() {
  return (
    <section
      id="vision"
      className="relative overflow-hidden border-y border-white/10 py-32 lg:py-44"
      data-testid="vision-section"
    >
      <div className="absolute inset-0 -z-10 grid-lines opacity-60" />
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[900px] -translate-x-1/2 rounded-full opacity-[0.12] blur-[140px]"
        style={{ background: "var(--accent)" }}
      />
      <div className="mx-auto max-w-5xl px-6 text-center lg:px-10">
        <Reveal>
          <p className="font-mono text-xs text-white/40">07 // VISION</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display mx-auto mt-8 max-w-4xl text-4xl font-light leading-[1.1] tracking-tight text-white sm:text-6xl lg:text-7xl">
            The Future Isn't More Software.
            <br />
            <span className="text-glow" style={{ color: "var(--accent)" }}>
              It's Better Decisions.
            </span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="font-body mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-white/60">
            We believe the next generation of enterprise technology will not
            simply store information.
          </p>
        </Reveal>

        <div className="mx-auto mt-10 flex max-w-2xl flex-col gap-3">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c} delay={0.15 + i * 0.08}>
              <div className="flex items-center justify-center gap-4">
                <span className="font-mono text-xs text-white/30">
                  0{i + 1}
                </span>
                <span className="font-display text-xl font-light text-white/85 sm:text-2xl">
                  {c}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.5}>
          <p className="font-body mx-auto mt-12 max-w-xl text-white/45">
            This is the future Cogentis Technologies is building.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
